import React, { ReactNode } from 'react';
import * as S from './ProfileLayout.styled';
import { Footer } from '@/components/Footer/Footer';
import { Header } from '@/components/Header';
import { PageTopControls } from '@/components/PageTopControls';
import { TabBar } from '@/components/TabBar/TabBar';
import { MobileProfileHeader } from '@/features/Profile/core/MobileProfileHeader';
import { MobileProfileOverview } from '@/features/Profile/core/MobileProfileOverview';
import { ProfileNav } from '@/features/Profile/core/ProfileNav';
import { UserSummaryCard } from '@/features/Profile/core/UserSummaryCard';
import { useProfileCurrentPath } from '@/features/Profile/core/hooks';
import { useResponsive } from '@/hooks/useResponsive';
import { Toast } from '@/components/UI/Toast';

type ProfileLayoutProps = {
  children: ReactNode;
  mobileHeader?: {
    title: string;
  };
  hideFooter?: boolean;
};

export function ProfileLayout({
  children,
  mobileHeader,
  hideFooter,
}: ProfileLayoutProps) {
  const { isDesktop } = useResponsive();
  const currentPath = useProfileCurrentPath();

  return (
    <S.Page>
      {isDesktop && (
        <PageTopControls>
          <Header />
        </PageTopControls>
      )}

      {!isDesktop &&
        (mobileHeader ? (
          <MobileProfileHeader
            title={mobileHeader.title}
            currentPath={currentPath}
          />
        ) : (
          <MobileProfileOverview currentPath={currentPath} />
        ))}

      <S.Main>
        {isDesktop && (
          <S.Sidebar>
            <UserSummaryCard />
            <ProfileNav currentPath={currentPath} />
          </S.Sidebar>
        )}

        <S.Content $hasCompactHeader={Boolean(mobileHeader)}>
          {children}
        </S.Content>
      </S.Main>

      {isDesktop ? (
        <S.DesktopFooter hasRegions={false} />
      ) : (
        !hideFooter && <Footer />
      )}
      {!isDesktop && !hideFooter && <TabBar />}

      <Toast />
    </S.Page>
  );
}
